<div class="main row">
  <section>
    <div class="row">
      <p
        dsContent
        [contentPath]="'goPaperless.goPaperLessPageDetails'"
        [options]="{ userEmailAddress: userEmailAddress$ | async }"
      ></p>
      <div>
        <a href="javascript:void(0)" (click)="showModal = true">Terms & Conditions</a>
      </div>
      <p dsContent [contentPath]="'goPaperless.goPaperLessPageDetailsFooter'"></p>
    </div>
    <!-- Action Buttons -->
    <div class="column twelve callToAction">
      <span class="md-float-right">
        <a class="md-pad-horizontal-20" (click)="navigateToOverview(true)"
          >Keep my existing preferences</a
        >
        <button ds-button type="click" (click)="goPaperLess()" class="-outline margin-right-20">
          Go paperless
        </button>
      </span>
    </div>
  </section>
</div>

<ds-policy-terms-and-conditions
  [showPaperless]="showPaperLess"
  [(visible)]="showModal"
></ds-policy-terms-and-conditions>
